import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="select-toggle"
export default class extends Controller {
  static targets = [ "select", "detail" ]
  static values = { criteria: String }

  connect() {
    if (this.selectTarget.value === this.criteriaValue) {
      this.detailTarget.classList.remove("hidden")
    }
  }

  toggle(e) {
    if (e.target.value === this.criteriaValue) {
      this.detailTarget.classList.remove("hidden")
    } else {
      this.detailTarget.classList.add("hidden")
    }
  }
}
